import * as React from 'react';
import { ReactNode } from 'react';
import {
  INewsItem,
} from '../model';

export interface IGetDomNewsMetaOptions {

}
export function getDomNewsMeta(news: INewsItem, customOptions?: IGetDomNewsMetaOptions): ReactNode {
  let options: IGetDomNewsMetaOptions = customOptions;
  let domMeta: ReactNode = null;
  if (customOptions === undefined || customOptions === null) {
    options = {};
  }
  if (news.list_article_from) {
    domMeta = (
      <React.Fragment>
        { news.list_article_from }
      </React.Fragment>
    );
  } else {
    domMeta = (
      <React.Fragment>
        { news.title }
      </React.Fragment>
    );
  }
  return domMeta;
}
